import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { EditableFormComponent } from 'src/app/components/editable-form/editable-form.component';
import { InputChooseComponent } from 'src/app/components/input/input-choose/input-choose.component';
import { ToolbarButton } from 'src/app/components/toolbar/toolbar.component';
import { CidadeDaoService } from 'src/app/dao/cidade-dao.service';
import { DocumentoDaoService } from 'src/app/dao/documento-dao-service';
import { UsuarioDaoService } from 'src/app/dao/usuario-dao.service';
import { IIndexable } from 'src/app/models/base.model';
import { Cidade } from 'src/app/models/cidade.model';
import { Documento } from 'src/app/models/documento.model';
import { UsuarioCertificado } from 'src/app/models/usuario-certificado.model';
import { PageFrameBase } from 'src/app/modules/base/page-frame-base';
import { LookupItem } from 'src/app/services/lookup.service';

@Component({
  selector: 'app-assinar',
  templateUrl: './documentos-assinar.component.html',
  styleUrls: ['./documentos-assinar.component.scss']
})
export class DocumentosAssinarComponent extends PageFrameBase {
  @ViewChild(EditableFormComponent, { static: false }) public editableForm?: EditableFormComponent;
  @ViewChild("certificadoChoose", { static: false }) public certificadoChoose?: InputChooseComponent;
  @ViewChild("senhaCertificadoForm", { static: false }) public senhaCertificadoForm?: TemplateRef<any>;
  public documentoDao: DocumentoDaoService;
  public usuarioDao: UsuarioDaoService;
  public textoConfirmar: string = "confirmo";
  public formCertificado: FormGroup;
  public documentos: Documento[] = [];
  public certificadoId: FormControl = new FormControl();
  public certificados: LookupItem[] = [];
  public certificadosButtons: ToolbarButton[] = [
    {
      icon: "bi bi-plus-circle",
      color: "btn-outline-success",
      label: 'Incluir',
      onClick: this.onIncluirCertificadoClick.bind(this)
    }
  ];
  public incluirCertificadoButtons: ToolbarButton[] = [
    {
      icon: "bi-check-circle",
      color: "btn-outline-success",
      label: 'Enviar',
      onClick: this.onEnviarCertificadoClick.bind(this)
    },
    {
      icon: "bi bi-dash-circle",
      color: "btn-outline-danger",
      label: 'Cancelar',
      onClick: this.onCancelarInclusaoCertificadoClick.bind(this)
    }
  ];
  public TIPO_ASSINATURA: LookupItem[] = [
    { key: "ELETRONICA", value: "Assinatura Eletrônica" },
    { key: "DIGITAL", value: "Assinatura Digital" }
  ];

  public isProcessandoClique = false;
  public isIncluindoCertificado = false;
  public avancadoNovaSenha = false;

  constructor(public injector: Injector) {
    super(injector);
    this.documentoDao = injector.get<DocumentoDaoService>(DocumentoDaoService);
    this.usuarioDao = injector.get<UsuarioDaoService>(UsuarioDaoService);
    this.modalWidth = 450;
    this.form = this.fh.FormBuilder({
      tipo: { default: "ELETRONICA" },
      confirmacao: { default: "" },
      avancada: { default: false },
      senha: { default: "" },
      usuario_certificado_id: { default: null }
    }, this.cdRef, this.validate);
    this.formCertificado = this.fh.FormBuilder({
      descricao: { default: "" },
      senha: { default: "" },
      arquivo: { default: null },
    }, this.cdRef, this.validateCertificado);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.documentos = this.metadata?.documentos;
  }

  public validate = (control: AbstractControl, controlName: string) => {
    let result = null;
    if (this.form?.controls.tipo.value == "ELETRONICA") {
      if(this.form?.controls.avancada.value) {
        if(controlName == "senha" && control.value.length < 4) {
          result = "A senha menor que 4 caracteres";
        }
      } else {
        if(controlName == "confirmacao" && control.value.toLowerCase() != this.textoConfirmar.toLowerCase()) {
          result = "Valor deverá ser " + this.textoConfirmar;
        }
      }
    } else if (this.form?.controls.tipo.value == "DIGITAL") {
      if(controlName == "certificado_id" && !control.value?.length) {
        result = "Obrigatório selecionar um certificado";
      }
    }
    return result;
  }

  public validateCertificado = (control: AbstractControl, controlName: string) => {
    let result = null;
    if(controlName == "arquivo" && !control.value?.length) {
      result = "Obrigatório selecionar um arquivo";
    } else if(["descricao", "senha"].includes(controlName) && !control.value?.length) {
      result = "Obrigatório";
    }
    return result;
  }

  public async onTipoChange(event: Event) {
    if(this.form?.controls.tipo.value == "DIGITAL" && this.certificados.length <= 1) {
      this.loading = true;
      try {
        let certificados = await this.usuarioDao.listarCertificados();
        this.certificados = [];
        /* 
        this.certificados.push(this.asLookupItem(new UsuarioCertificado({
          id: "WEBCRYPTO",
          descricao: "Certificado do computador",
          tipo: "WEBCRYPTO",
          valido: true
        })));
        */
        this.certificados!.push(...certificados?.map(x => this.asLookupItem(x)!) || []);
        this.form!.controls.usuario_certificado_id.setValue("WEBCRYPTO");
      } catch (error) {
        this.error(error);
      } finally {
        this.loading = false;
      }
    }
    this.fh.revalidate(this.form!);
  }

  public onIncluirCertificadoClick() {
    this.isIncluindoCertificado = true;
    this.formCertificado!.patchValue({
      descricao: '',
      arquivo: null,
      senha: ''
    });
    this.cdRef.detectChanges();
  }

  public async onEsqueciClick() {
    this.avancadoNovaSenha = true;
    this.form!.controls.senha.setValue('');
    this.cdRef.detectChanges();
    let result = await this.dialog.template({ title: "Criar nova senha", modalWidth: 500 }, this.senhaCertificadoForm!, [
      {
        label: "Criar senha",
        icon: "bi bi-check-circle",
        color: "btn-outline-success",
        value: "CRIAR",
        disabled: this.criarSenhaDisabled.bind(this)
      }, {
        label: "Cancelar",
        icon: "bi bi-dash-circle",
        color: "btn btn-outline-danger",
        value: "CANCELAR"
      }
    ]).asPromise();
    this.avancadoNovaSenha = false;
    if (result.button.value == "CRIAR") {
      try {
        await this.usuarioDao.criarSenhaAssinaturaAvancada(this.form!.controls.senha.value);
        await this.dialog.alert('Criado com sucesso', 'Nova senha criada com sucesso');
      } catch (error: any) {
        await this.dialog.alert('Erro', 'Erro ao criar a senha' + (error?.message ? error?.message : error));
      }
    }
    result.dialog.close();
  }

  public criarSenhaDisabled(): boolean {
    return this.form!.controls.senha.value.length < 4;
  }

  public async onEnviarCertificadoClick() {
    this.fh.revalidate(this.formCertificado!);
    if(this.formCertificado!.valid) {
      this.submitting = true;
      try {
        let certificado = await this.usuarioDao.incluirCertificado(this.formCertificado!.controls.descricao.value, this.formCertificado!.controls.arquivo.value, this.formCertificado!.controls.senha.value);
        let item = this.asLookupItem(certificado);
        if(item) this.certificados?.unshift(item);
        this.isIncluindoCertificado = false;
        this.cdRef.detectChanges();
      } catch (error) {
        this.error(error);
      } finally {
        this.submitting = false;
      }
    }
  }

  public asLookupItem(certificado: UsuarioCertificado): LookupItem {
    certificado.dados = certificado.dados || {};
    certificado.dados.image = 
      (certificado.tipo == "PKCS12" && certificado.valido ? 'assets/images/certificado_pfx.png' :
      (certificado.tipo == "PKCS12" && !certificado.valido ? 'assets/images/certificado_pfx_expirado.png' : 
      (certificado.tipo == "WEBCRYPTO" ? 'assets/images/certificado_web_crypto.png' : '')));
    return !certificado ? { 
      key: '', 
      value: 'Desconhecido',
      color: '#006FFF'
    } : {
      key: certificado.id,
      value: certificado.descricao || certificado.dados?.commonName || certificado.dados?.emailAddress || certificado.dados?.subjectNameValue || certificado.numero_serie || "Desconhecido",
      data: certificado,
      color: '#006FFF'
    };
  }

  public onCancelarInclusaoCertificadoClick() {
    this.isIncluindoCertificado = false;
    this.cdRef.detectChanges();
  }

  public async onAssinarClick() {
    if (this.isProcessandoClique || this.isIncluindoCertificado) return;
    this.isProcessandoClique = true;
    try {
      let response: Documento[] | undefined = undefined;
      let tipo = this.form!.controls.tipo.value == "DIGITAL" ? this.certificadoChoose?.selectedItem?.data?.tipo : this.form!.controls.avancada.value ? "SELFSIGNED" : "GUID";
      let certificadoId = tipo == "PKCS12" ? this.form!.controls.usuario_certificado_id.value : undefined;
      let senha = undefined;
      if (tipo == "PKCS12") {
        let result = await this.dialog.template({ title: "Senha do certificado", modalWidth: 500 }, this.senhaCertificadoForm!, [
          {
            label: "Assinar",
            icon: "bi bi-check-circle",
            color: "btn-outline-success",
            value: "ASSINAR"
          }, {
            label: "Cancelar",
            icon: "bi bi-dash-circle",
            color: "btn btn-outline-danger",
            value: "CANCELAR"
          }
        ]).asPromise();
        if (result.button.value == "ASSINAR") {
          senha = this.form!.controls.senha.value;
          result.dialog.close();
        } else {
          result.dialog.close();
          return false;
        }
      } else if (tipo == "SELFSIGNED") {
        senha = this.form!.controls.senha.value;
      } else if (tipo == "WEBCRYPTO") {
        await this.dialog.alert("Em desenvolvimento", "Funcionalidade em desenvolvimento!");
        return false;
      }
      this.dialog.showSppinerOverlay("Assinando . . .");
      response = await this.documentoDao.assinar(tipo, this.documentos.map(x => x.id), certificadoId, senha);
      response?.forEach(atualizado => {
        const documento = this.documentos.find(x => x.id == atualizado.id);
        if (documento) documento.assinaturas = atualizado.assinaturas;
      });
      this.go.setModalResult(this.modalRoute?.queryParams?.idroute, response);
      this.close();
    } catch (error: any) {
      this.error(error);
    } finally {
      this.dialog.closeSppinerOverlay();
      this.isProcessandoClique = false;
    }
    return false;
  }

}

